import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'


export default class extends React.Component {
  state = {
  }

  constructor(props) {
    super(props)
    let { language } = this.props
  }

  // shouldComponentUpdate(nextProps) {
  //   console.log('shouldComponentUpdate')
  //   // return false
  // }

  componentDidMount() {
    // console.log('componentDidMount')
  }

  componentWillReceiveProps(e) {
    // console.log('componentWillReceiveProps')
  }

  render() {
    let { language, lang } = this.props
    return (
      <div className="copyright">
        <div className="ti">
          {lang.copyright}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/202408tr/Copyright/index.js